import PropTypes from 'prop-types';
import { memo } from 'react';

import { emptyObject } from '../../utils';

import csLvlColor from './csLvlColor';

const alertCloseOpacity = 0.45;

const CsLvlColorDiv = memo(
  ({
    csLvl,
    csClose = 0,
    csCancel = 0,
    csHold = 0,
    csBtwnUsrs = 0,
    csUsrsCflct = 0,
    style = emptyObject,
    className,
  }) => {
    const color = csLvlColor(
      csLvl,
      // csClose,
      // csHold,
      csBtwnUsrs,
      csUsrsCflct,
    );
    let opacity;

    // console.log(`CsLvlColorDiv csLvl ${csLvl} csClose ${csClose} csHold ${
    //   csHold} csBtwnUsrs ${csBtwnUsrs} csUsrsCflct ${csUsrsCflct}`);

    if (csClose || csHold || csCancel) opacity = alertCloseOpacity;

    return (
      <div
        className={className}
        style={{
          ...style,
          backgroundColor: color,
          opacity,
        }}
      />
    );
  },
);

CsLvlColorDiv.propTypes = {
  csLvl: PropTypes.number,
  csClose: PropTypes.number,
  csCancel: PropTypes.number,
  csHold: PropTypes.number,
  csBtwnUsrs: PropTypes.number,
  csUsrsCflct: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

CsLvlColorDiv.displayName = 'CsLvlColorDiv';

export default CsLvlColorDiv;
